module.exports = __webpack_public_path__ + "img/CQFSIcon.ab9c65a6.png";